//import hook react
import React, { useState, useEffect } from 'react';

//import hook useHitory from react router dom
import { useHistory } from 'react-router';

//import axios
import axios from 'axios';

function Login() {

    //define state
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    //define state validation
    const [validation, setValidation] = useState([]);

    //define history
    const history = useHistory();

    //hook useEffect
    useEffect(() => {

        //check token
        if (localStorage.getItem(process.env.REACT_APP_TOKEN_NAME)) {

            //redirect page dashboard
            history.push('/dashboard');
        }
        else {
            //initialize formData
            const state = stringGen(40);
            const formData = new URLSearchParams();
            formData.append('client_id', process.env.REACT_APP_CLIENT_ID);
            formData.append('redirect_uri', process.env.REACT_APP_WEB_URL + '/callback');
            formData.append('response_type', 'code');
            formData.append('scope', '');
            formData.append('state', stringGen(40));
            localStorage.setItem('state', state);
            
            window.location.assign(process.env.REACT_APP_API_URL + '/oauth/authorize?' + formData.toString());

            //history.push({ pathname: process.env.REACT_APP_API_URL + '/oauth/authorize', state: state });

            // await axios.post(process.env.REACT_APP_API_URL + '/oauth/authorize', formData)
            //     .then((response) => {

            //         //set token on localStorage
            //         localStorage.setItem(process.env.REACT_APP_TOKEN_NAME, response.data.token);
            //         setCookie('sso-cookie', response.data.token);
            //         //redirect to dashboard
            //         history.push('/dashboard');
            //     })
            //     .catch((error) => {

            //         //assign error to state "validation"
            //         setValidation(error.response.data);
            //     })
        }
    }, []);

    function stringGen(len) {
        var text = "";
        
        var charset = "abcdefghijklmnopqrstuvwxyz0123456789";
        
        for (var i = 0; i < len; i++)
          text += charset.charAt(Math.floor(Math.random() * charset.length));
        
        return text;
      }

    //function "loginHanlder"
    const loginHandler = async (e) => {
        e.preventDefault();

        //initialize formData
        const formData = new FormData();

        //append data to formData
        formData.append('email', email);
        formData.append('password', password);

        //send data to server
        // await axios.post(process.env.REACT_APP_API_URL + '/login', formData)
        //     .then((response) => {

        //         //set token on localStorage
        //         localStorage.setItem(process.env.REACT_APP_TOKEN_NAME, response.data.token);
        //         setCookie('sso-cookie', response.data.token);
        //         //redirect to dashboard
        //         history.push('/dashboard');
        //     })
        //     .catch((error) => {

        //         //assign error to state "validation"
        //         setValidation(error.response.data);
        //     })


    };

    function setCookie(cname, cvalue) {
        const d = new Date();
        d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    /*return (
        <div className="container" style={{ marginTop: "10px" }}>
            <div className="row justify-content-center">
                <div className="col-md-4">
                    <div className="card border-0 rounded shadow-sm">
                        <div className="card-body">
                            <div className="text-center text-dark mb-4 mt--4">
                                <div className="text-center">
                                    <img className="mb-3" src="logo1.png" width="150" alt=""></img>
                                    <h4 className="fw-bold">Single Sign On</h4>
                                </div>
                            </div>
                            <div className="text-center" style={{ fontSize: "15px" }}> Silakan login terlebih dahulu </div>

                            <hr />
                            {
                                validation.message && (
                                    <div className="alert alert-danger">
                                        {validation.message}
                                    </div>
                                )
                            }
                            <form onSubmit={loginHandler}>
                                <div className="mb-3">
                                    <label className="form-label">EMAIL / NIDN / NIM</label>
                                    <input type="text" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Masukkan Email / NIDN / NIM" />
                                </div>
                                {
                                    validation.email && (
                                        <div className="alert alert-danger">
                                            {validation.email[0]}
                                        </div>
                                    )
                                }
                                <div className="mb-3">
                                    <label className="form-label">PASSWORD</label>
                                    <input type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Masukkan Password" />
                                </div>
                                {
                                    validation.password && (
                                        <div className="alert alert-danger">
                                            {validation.password[0]}
                                        </div>
                                    )
                                }
                                <div className="text-right" style={{ fontSize: "15px" }}>
                                    <a href='/forgotpassword'>Lupa password?</a>
                                </div>
                                <br></br>
                                <div className="d-grid gap-2">
                                    <button type="submit" className="btn btn-primary btn-lg btn-block">
                                        LOGIN <i className="fas fa-arrow-right ml-1"></i>
                                    </button>
                                </div>
                            </form>
                            <div className="text-center mt-2 mb-4">
                                &copy; {new Date().getFullYear()} &nbsp;
                                <a href="https://bpti.uhamka.ac.id/" target="_blank">
                                    BPTI UHAMKA
                                </a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )*/

}

export default Login;